<template functional>
  <rich-text standard>
    <slot />
  </rich-text>
</template>

<script>
export default {
  name: 'SanityStandardContainer',

  functional: true
}
</script>
